import React from "react";

import MainButton from "../button";
import Typography from "../typography";
import StatusIcon from "./StatusIcon";

const WizardStatus = ({
  status,
  data,
  onAddAnyway,
}) => {
  if (!data) {
    return null;
  }

  return (
    <ul className={`status-container ${status}`}>
      <li className={`status-icon-container`}>
        <span>
          <StatusIcon status={status} />
        </span>
        <Typography className={"center"} variant="title" text={data.title} />
      </li>
      {data?.subTitle &&
        data?.subTitle.length > 0 &&
        data?.subTitle.map((item, index) => {
          return (
            <li key={item} className="sub-title-text">
              <Typography
                className={"center title"}
                variant="sub-title"
                text={data.status === "42" ? `${index + 1}. ${item}` : item}
              />
            </li>
          );
        })}

      {data.status === "42" && (
        <li className="description-button">
          <MainButton
            text="Add it anyway"
            variant="success"
            onClick={onAddAnyway}
          />
        </li>
      )}
      {data?.description && (
        <li className="description-text">
          <Typography
            className={"force-color center"}
            variant="description"
            text={data.description || "Description"}
          />
        </li>
      )}
    </ul>
  );
};

export default WizardStatus;
